import {
  Avatar,
  Box,
  Button,
  Flex,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import iconCheckRed from "../../assets/images/iconCheckRed.png";
import iconRejected from "../../assets/images/contract/x-circle.svg";
import { RiResetLeftFill } from "react-icons/ri";
import { MdAutorenew } from "react-icons/md";
import { formatNumber } from "../../utils/utils";
import { useEffect, useState } from "react";
import { roundNumber0 } from "../../utils/tools";

export const EditableCell = ({ initialValue, keyName, onSubmit, id }) => {
  const [rawValue, setRawValue] = useState(initialValue?.toString() || "");

  useEffect(() => {
    setRawValue(roundNumber0(Number(initialValue?.toString() || "")));
  }, [initialValue]);

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";

    const [intPart, decimalPart] = value.toString().split(".");
    const formattedInt = Number(roundNumber0(intPart) || "0").toLocaleString(
      "en-US",
    );

    if (value.endsWith?.(".")) return `${formattedInt}.`;
    if (decimalPart !== undefined) return `${formattedInt}.${decimalPart}`;
    return formattedInt;
  };

  const handleChange = (e) => {
    const input = e.target.value;

    // Cho phép nhập số và 1 dấu chấm
    if (!/^\d*\.?\d*$/.test(input.replace(/,/g, ""))) return;

    // Xóa dấu phẩy để lấy raw
    const cleaned = input.replace(/,/g, "");
    setRawValue(roundNumber0(cleaned));
  };

  const handleBlur = () => {
    const parsed = Math.round((parseFloat(rawValue) || 0) * 100) / 100;

    onSubmit("remainingRevenueAfterTax", id, roundNumber0(parsed), keyName);

    // Reset lại rawValue để đảm bảo state hợp lệ
    setRawValue(roundNumber0(parsed.toString()));
  };

  return (
    <Input
      type="text"
      value={formatNumber(rawValue)}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="Nhập số"
      border="1px solid red"
      _hover={{ borderColor: "red" }}
      _focus={{ borderColor: "red", boxShadow: "0 0 0 1px red" }}
    />
  );
};

export const formatTableValue = (value, key, submit, id, statusData) => {
  function formatNumber(val) {
    if (val === null || val === undefined || val === "") return "";
    return Number(roundNumber0(val)).toLocaleString("en-US");
  }
  switch (key) {
    case "remainingRevenueAfterTax":
      if (statusData) {
        return (
          <EditableCell
            initialValue={value}
            keyName={key}
            onSubmit={submit}
            id={id}
          />
        );
      } else {
        return <Text>{value}</Text>;
      }

    case "commissionPrice":
      if (statusData) {
        return (
          <Text lineHeight={"28px"} cursor={"pointer"} fontWeight={"500"}>
            {value ? `${formatNumber(value)} VNĐ` : "0 VNĐ"}
          </Text>
        );
      } else {
        return <Text>{value}</Text>;
      }

    case "remainingCommissionPrice":
      if (statusData) {
        return (
          <Text lineHeight={"28px"} cursor={"pointer"} fontWeight={"500"}>
            {value ? `${formatNumber(value)} VNĐ` : "0 VNĐ"}
          </Text>
        );
      } else {
        return <Text>{value}</Text>;
      }

    case "status":
      let content;
      if (value === "PAID") {
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconApproved} w={"20px"} />
              <Text color={"var(--color-status-employ)"}>Đã thanh toán</Text>
            </Flex>
          </Flex>
        );
      } else if (value === "PARTIAL") {
        content = (
          <Flex align={"center"} gap={1}>
            <MdAutorenew
              size={20}
              color={"var(--color-option-employee-hover)"}
            />
            <Text
              color={"var(--color-option-employee-hover)"}
              w={"max-content"}
              minW={"max-content"}
              display={"block"}
            >
              Đang thanh toán
            </Text>
          </Flex>
        );
      } else {
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconRejected} w={"20px"} />
              <Text color={"var(--text-red-employee)"}>Chưa thanh toán</Text>
            </Flex>
          </Flex>
        );
      }

      return (
        <Flex gap={"8px"} w={"max-content"}>
          {content}
        </Flex>
      );
    default:
      return <Text>{value}</Text>;
  }
};
